import styled from "styled-components";
import approveImage from "../../assets/images/approve.png";

export interface ISuccessModalProps {
  onProceedClick: () => void;
}

const ModalWrapper = styled.div`
  width: 35rem;
  background-color: ${({ theme }) => theme.bg.prim_300};
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  align-self: center;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 3rem 3rem;

  img {
    width: 5rem;
  }

  .congrat-title {
    margin-top: 1.5rem;
    font-size: 1.8rem;
    color: ${({ theme }) => theme.text.secondary};
  }

  p {
    margin-top: 0.5rem;
    text-align: center;
    font-size: 0.85rem;
    color: ${({ theme }) => theme.text.primary_100};
    line-height: normal;
  }

  .button-proceed {
    margin-top: 2rem;
  }

  .close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #b45d5d;
    cursor: pointer;
    transition: all 0.3s ease;

    font-size: 1rem;
    background: ${({ theme }) => theme.bg.prim_400};

    &:hover {
      color: red;
      background: ${({ theme }) => theme.bg.prim_500};
      transition: all 0.3s ease;
      font-weight: bold;
    }
  }
`;

export function SuccessModal({ onProceedClick }: ISuccessModalProps) {
  return (
    <ModalWrapper>
      <div className="close" onClick={onProceedClick}>
        X
      </div>
      <img src={approveImage} alt="approval" />
      <h2 className="congrat-title">Congratulation</h2>
      <p>
        A verification link has been sent to your email and an OTP, Check your
        email and follow the link on your email to verify your email
      </p>
    </ModalWrapper>
  );
}
